<blaze-panel>
  <div icon class="icon-settings"></div>

  <div title>Setup Api Builder</div>

  <ng-container actions>
    <blaze-environment-indicator class="mr-6" />

    <blaze-copy-connector-config-env-button
      (copyConfiguration)="copyConfiguration($event)"
      [coupledConnector]="(coupledConnector$ | async) || undefined"
    />

    <button
      (click)="upsertConnector()"
      [disabled]="(valid$ | async) === false || (savingConnector$ | async) === true"
      blazeBarButton="primary"
    >
      {{ upsertConnectorLabel$ | async }}
    </button>
  </ng-container>

  <div content class="panel-content">
    <div class="form-control mb-24">
      <label class="field-label bd-field-label required mb-8">Name Your Connector</label>
      <div class="bd-accent-wrapper">
        <input
          [formControl]="connectorNameCtrl"
          class="bd-text-input tall w-full"
          name="connectorName"
          placeholder="i.e. 'Production DB' or 'Internal API'"
        />
      </div>
    </div>
    <blaze-api-builder [showValidation]="showValidation" />
    <blaze-element-loading-indicator [isVisible]="savingConnector$ | async" />
  </div>
</blaze-panel>
